import { RESET_SHARE_STATE } from "./actionTypes";

const initState = {
  urls: [],
  showShareModal: false,
  message: "",
  progressBar: false,
  isImagesShared: false,
  isDescriptionShared: false,
};

const INIT_SHARE_DIALOG = "INIT_SHARE_DIALOG";
const TOGGLE_PROGRESS_BAR = "TOGGLE_PROGRESS_BAR";
const INIT_STATE = "INIT_STATE";
const CHANGE_IMAGE_STATUS = "CHANGE_IMAGE_STATUS";
const CHANGE_DESCRIPTION_STATUS = "CHANGE_DESCRIPTION_STATUS";

export const actions = {
  initShareDialog(payload) {
    return {
      type: INIT_SHARE_DIALOG,
      payload,
    };
  },
  toggleProgressBar(payload) {
    return {
      type: TOGGLE_PROGRESS_BAR,
      payload,
    };
  },
  returnToInitState() {
    return {
      type: INIT_STATE,
    };
  },
  changeImageSharedStatus() {
    return {
      type: CHANGE_IMAGE_STATUS,
    };
  },
  changeDescriptionStatus() {
    return {
      type: CHANGE_DESCRIPTION_STATUS,
    };
  },
};

const shareReducer = (state = initState, action) => {
  switch (action.type) {
    case INIT_SHARE_DIALOG: {
      const { payload } = action;

      return {
        ...state,
        ...payload,
      };
    }

    case TOGGLE_PROGRESS_BAR: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }

    case INIT_STATE: {
      return {
        ...initState,
      };
    }

    case CHANGE_IMAGE_STATUS: {
      return {
        ...state,
        isImagesShared: true,
        progressBar: false,
      };
    }

    case CHANGE_DESCRIPTION_STATUS: {
      return {
        ...state,
        isDescriptionShared: true,
      };
    }

    case RESET_SHARE_STATE: {
      return initState;
    }

    default:
      return state;
  }
};

shareReducer.initialState = initState;

export default shareReducer;
